
import { getScannedItemsFromDatabase } from "../services/FireBaseService";

export async function fetchScannedItems() {
  try {
    const scannedItems = await getScannedItemsFromDatabase();
    const safeItems = [];
    const unsafeItems = [];

    scannedItems.forEach(item => {
      if (item.isSafe) {
        safeItems.push(item);
      } else {
        unsafeItems.push(item);
      }
    });

    console.log("Sikre produkter:", safeItems);
    console.log("Usikre produkter:", unsafeItems);

    return { safeItems, unsafeItems };
  } catch (error) {
    console.error("Fejl ved hentning af scannede varer:", error.message);
    throw new Error("Kunne ikke hente scannede varer.");
  }
}
